import { render } from "./ImportResourcePopup.vue?vue&type=template&id=31d45b70&scoped=true&ts=true"
import script from "./ImportResourcePopup.vue?vue&type=script&lang=ts"
export * from "./ImportResourcePopup.vue?vue&type=script&lang=ts"

import "./ImportResourcePopup.vue?vue&type=style&index=0&id=31d45b70&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d45b70"]])

export default __exports__